import Endpoint from './lib/standard_gateway/endpoint';
import SidekickHttpGateway, { SIDEKICK_FETCH_TIMEOUT } from './sidekick_http_gateway';

export default class SidekickFlowsHttpGateway extends SidekickHttpGateway {
  constructor(backend) {
    super(backend, 'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows/:id');
  }

  validateLiquid(params, data, httpOptions) {
    const paramsLocal = { ...params, ...this.endpoint.params };
    const endpoint = new Endpoint(
      'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/validate-liquid',
      paramsLocal
    );

    const options = { ...httpOptions, timeout: SIDEKICK_FETCH_TIMEOUT };

    const url = this.buildUrl(endpoint.set(paramsLocal).fetchUrl, {});
    const resource = this.endpoint.patterns.fetchUrl;

    return this.http.post(url, data, options, resource);
  }

  renderLiquid(params, data, httpOptions) {
    const paramsLocal = { ...params, ...this.endpoint.params };
    const endpoint = new Endpoint(
      'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/render-liquid',
      paramsLocal
    );

    const options = { ...httpOptions, timeout: SIDEKICK_FETCH_TIMEOUT };

    const url = this.buildUrl(endpoint.set(paramsLocal).fetchUrl, {});
    const resource = this.endpoint.patterns.fetchUrl;

    return this.http.post(url, data, options, resource);
  }

  validateRegex(params, data, httpOptions) {
    const paramsLocal = { ...params, ...this.endpoint.params };
    const endpoint = new Endpoint(
      'v1/orgs/:orgId/sidekick-dashboard/customers/:customerId/flows-next/validate-regex',
      paramsLocal
    );

    const options = { ...httpOptions, timeout: SIDEKICK_FETCH_TIMEOUT };

    const url = this.buildUrl(endpoint.set(paramsLocal).fetchUrl, {});
    const resource = this.endpoint.patterns.fetchUrl;

    return this.http.post(url, data, options, resource);
  }
}
